module.exports = __webpack_public_path__ + "static/media/how_to_4.694f0740.svg";